import * as Sentry from "@sentry/react";

import { getEnvironment } from "./api";

export const initSentry = () => {
  const environment = getEnvironment();

  if (environment === "production") {
    Sentry.init({
      dsn: "https://ac796322226b7392999be73263a06c3d@o1302227.ingest.us.sentry.io/4510940712665088",
      environment: "production",
      integrations: (defaults) =>
        defaults.filter(
          (integration) =>
            integration.name !== "GlobalHandlers" &&
            integration.name !== "Breadcrumbs" &&
            integration.name !== "BrowserApiErrors"
        ),
      beforeSend(event) {
        if (!event.tags?.operation) {
          return null;
        }
        if (event.extra) {
          delete event.extra.patientName;
          delete event.extra.patientDob;
          delete event.extra.patientEmail;
          delete event.extra.patientPhone;
        }
        return event;
      },
    });
  }
};
